import multiguard from 'vue-router-multiguard';
import { mapState } from 'vuex';
import { routerCheckIsZeroUsageReportSubmission } from '../utils';

export default {
    name: 'ZeroUsageConfirmation',
    template: '#no-usages-confirmation-template',
    computed: {
        ...mapState([
            'permitYear'
        ])
    },
    beforeRouteEnter: multiguard([
        routerCheckIsZeroUsageReportSubmission
    ])
};